import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import cn from "classnames"
import { connect } from 'react-redux'
import {CONTENT_ROUTE, trackEvent} from "../../actions"
import URL from "../../utils/URL"
import injectSheet from 'react-jss'
import {BASE_URL} from '../../config'
import theme from '../../styles/theme'

class RichTextContainer extends PureComponent {

    // this handles the internal clicks
    _handleHtmlContentClick = (e) => {
        const {handleNavigate, handleTracking, ga_tracking} = this.props

        if (e.defaultPrevented) {
            return;
        }
        if (e.metaKey || e.ctrlKey || e.shiftKey) {
            return;
        }
        if (e.button !== 0) {
            return;
        }
        // Get the <a> element.
        var el = e.target;
        while (el && el.nodeName !== 'A') {
            el = el.parentNode;
        }
        // Ignore clicks from non-a elements.
        if (!el) {
            return;
        }
        // Ignore the click if the element has a target.
        if (el.target && el.target !== '_self') {
            handleTracking(ga_tracking);
            return;
        }

        const targetUrl = new URL(el.href);
        const currentURL = new URL(window.location.href);

        // Ignore links that don't share a protocol and host wi
        // th ours.
        if (targetUrl.protocol !== currentURL.protocol || targetUrl.host !== currentURL.host
            || ! targetUrl.pathname.startsWith(BASE_URL)) {
            handleTracking(el.href, ga_tracking);
            // This may change later on
            //el.target = "_blank"
            return;
        }

        // Prevent :focus from sticking; preventDefault() stops blur in some browsers
        el.blur();
        e.preventDefault();

        /// using the router, go to that url
        handleNavigate(targetUrl, ga_tracking);
    }


    render() {
        const { classes, className, content, removeBottomMargin, applyDropCap } = this.props
        return <div data-cy="richTextContainer" className={cn( {[classes.noBottomMargin]: removeBottomMargin }, {[classes.applyDropCap]: applyDropCap }, className)}
                    onClick={this._handleHtmlContentClick} dangerouslySetInnerHTML={{__html: content}} ref={this._setRef}></div>
    }
}

RichTextContainer.propTypes = {
    content: PropTypes.string.isRequired,
    removeBottomMargin: PropTypes.bool,
    ga_tracking: PropTypes.object
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => {
    return {
        handleTracking: (url, ga_tracking) => {
            dispatch( trackEvent( url, ga_tracking) );
        },
        handleNavigate: (targetUrl, ga_tracking) => {
            dispatch( trackEvent(targetUrl.toString(), ga_tracking) );
            dispatch( { type: CONTENT_ROUTE, payload: [ targetUrl.pathname ] } );
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet({
    noBottomMargin: {
        "& > :last-child": {
            marginBottom: "0 !important",
        }
    },
    applyDropCap: {
        '& > p:first-letter': {
            float: 'left',
            fontSize: 80,
            lineHeight: 1.1,
            margin: [7, 9, -24, 0],
            fontFamily: theme.font.titleFontFamily,
            [theme.breakpoint("tablet")]: {
                fontSize: 102,
                margin: [8, 9, -24, 0]
            }
        }
    }
})(RichTextContainer))



// WEBPACK FOOTER //
// ./src/components/Widgets/RichTextContainer.js